// src/utils/useOnScreen.js
import { useEffect, useRef, useState } from "react";

export const useOnScreen = (rootMargin = "400px") => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) setVisible(true);
      },
      { root: null, rootMargin, threshold: 0.01 }
    );
    const el = ref.current;
    if (el) io.observe(el);
    return () => io.disconnect();
  }, [rootMargin]);

  return [ref, visible];
};
